module.exports = __webpack_public_path__ + "media/images/emblems/Roches-coat_of_arms-9cf7e30d8db64dbf3c8dc297f8fc2605.svg";